import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaFilm } from 'react-icons/fa';

const Footer = () => {
  const movieGenres = ['Action', 'Sci-Fi', 'Drama', 'Adventure', 'Comedy', 'Horror', 'Animation', 'Thriller'];
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'Movies', path: '/movies' },
    { name: 'TV Series', path: '/series' },
  ];
  const legalLinks = ['Privacy Policy', 'Terms of Service', 'Cookie Preferences', 'Help Center'];

  return (
    <footer className="bg-dark-900 border-t border-white/5 mt-16">
      {/* Main Footer Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-accent-gold flex items-center justify-center text-dark-900 shadow">
                <FaFilm className="w-4 h-4" />
              </div>
              <div className="flex items-baseline">
                <span className="text-accent-gold text-xl font-black">Shadow</span>
                <span className="text-white text-xl font-bold">Cinema</span>
              </div>
            </Link>
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">
              Your ultimate cinematic platform for high-definition streaming, premier ticketing, and AI-powered recommendations.
            </p>
            <div className="flex items-center gap-2.5 pt-2">
              {[FaFacebookF, FaTwitter, FaInstagram, FaYoutube].map((Icon, idx) => (
                <a
                  key={idx}
                  href="#root"
                  aria-label="Social Link"
                  className="w-8 h-8 rounded-lg bg-dark-800 border border-white/10 flex items-center justify-center text-gray-400 hover:text-accent-gold hover:border-accent-gold/40 transition-all"
                >
                  <Icon className="w-3.5 h-3.5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="text-white font-bold text-sm tracking-wider uppercase mb-4">
              Navigation
            </h5>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-accent-gold text-xs sm:text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Genres */}
          <div>
            <h5 className="text-white font-bold text-sm tracking-wider uppercase mb-4">
              Explore Genres
            </h5>
            <div className="grid grid-cols-2 gap-2">
              {movieGenres.map((genre) => (
                <Link
                  key={genre}
                  to="/"
                  className="text-gray-400 hover:text-accent-gold text-xs transition-colors"
                >
                  {genre}
                </Link>
              ))}
            </div>
          </div>

          {/* Legal / Support */}
          <div>
            <h5 className="text-white font-bold text-sm tracking-wider uppercase mb-4">
              Support & Legal
            </h5>
            <ul className="space-y-2.5">
              {legalLinks.map((item) => (
                <li key={item}>
                  <a
                    href="#root"
                    className="text-gray-400 hover:text-accent-gold text-xs sm:text-sm transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} ShadowCinema Entertainment Inc. All rights reserved.</p>
          <p className="flex items-center gap-1">
            Built with <span className="text-accent-gold">♥</span> for movie lovers worldwide.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;